import CloseIcon from '@mui/icons-material/Close'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
} from '@mui/material'
import { connectField } from 'uniforms'
import { BoolFieldProps } from 'uniforms-mui'
import { useCiboAutoForm } from './CiboAutoForm'
import { ValidationMessages } from './ValidationMessages'

export function BooleanRadioInput(props: BoolFieldProps) {
  const { name, value, label, onChange, disabled, required } = props
  const { touch } = useCiboAutoForm()

  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      {label && <FormLabel component="legend">{label}</FormLabel>}

      <Stack direction="row" alignItems="center">
        <RadioGroup
          row
          name={name}
          value={value === undefined ? '' : value ? 'true' : 'false'}
          onChange={e => {
            const val = e.target.value
            if (val === 'true') onChange(true)
            else if (val === 'false') onChange(false)

            touch(name)
          }}
          onBlur={() => touch(name)}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={disabled} />
          <FormControlLabel value="false" control={<Radio />} label="No" disabled={disabled} />
        </RadioGroup>

        <Tooltip title="Clear selection">
          <IconButton
            aria-label="clear"
            onClick={() => onChange(undefined)}
            disabled={disabled || value === undefined}
            size="small"
            sx={{ marginLeft: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>

      <ValidationMessages
        fieldName={props.name}
        error={props.error as { message: string } | undefined}
      />
    </FormControl>
  )
}

export default connectField(BooleanRadioInput)
